var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBankCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 44.00 36.00",
    width: 44,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B595",
    d: " M 40.2877 28.0886 A 3.86 3.86 0.0 0 1 36.4344 31.9553 L 8.1344 32.0047 A 3.86 3.86 0.0 0 1 4.2677 28.1514 L 4.2323 7.8914 A 3.86 3.86 0.0 0 1 8.0856 4.0247 L 36.3856 3.9753 A 3.86 3.86 0.0 0 1 40.2523 7.8286 L 40.2877 28.0886 Z M 37.22 8.14 A 1.15 1.15 0.0 0 0 36.07 6.99 L 8.37 6.99 A 1.15 1.15 0.0 0 0 7.22 8.14 L 7.22 8.92 A 1.15 1.15 0.0 0 0 8.37 10.07 L 36.07 10.07 A 1.15 1.15 0.0 0 0 37.22 8.92 L 37.22 8.14 Z M 37.27 16.97 A 0.98 0.98 0.0 0 0 36.29 15.99 L 8.27 15.99 A 0.98 0.98 0.0 0 0 7.29 16.97 L 7.29 28.03 A 0.98 0.98 0.0 0 0 8.27 29.01 L 36.29 29.01 A 0.98 0.98 0.0 0 0 37.27 28.03 L 37.27 16.97 Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00B595",
    x: -2.98,
    y: -1.42,
    transform: "translate(13.28,24.53) rotate(-1.6)",
    width: 5.96,
    height: 2.84,
    rx: 1.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00B595",
    x: -5,
    y: -1.44,
    transform: "translate(23.24,24.51) rotate(-0.2)",
    width: 10,
    height: 2.88,
    rx: 1.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBankCard);
export default __webpack_public_path__ + "static/media/greenBankCard.8abb73511fa48976770cac84abd5f00a.svg";
export { ForwardRef as ReactComponent };